export default "__VITE_ASSET__Dq1xxoy8__"